/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { ILayoutSchema } from '../../entities/layout/LayoutSchema';

export type TGetNewbuildingLayoutsDesktopFicheringModel = IModel<
  IGetNewbuildingLayoutsDesktopFicheringRequest,
  TGetNewbuildingLayoutsDesktopFicheringResponse
>;

export interface IGetNewbuildingLayoutsDesktopFicheringRequest {
  /** Комнатность **/
  roomsCount?: ERoomsCount | null;
  /** ID ЖК **/
  newbuildingId?: number | null;
  /** ID Корпуса **/
  houseId?: number | null;
}

export type TGetNewbuildingLayoutsDesktopFicheringResponse =
  | IGetNewbuildingLayoutsDesktopFicheringResponse200
  | IGetNewbuildingLayoutsDesktopFicheringResponse400;

export interface IGetNewbuildingLayoutsDesktopFicheringResponse200
  extends IModelResponse<IGetNewbuildingLayoutsDesktopFicheringResponse> {
  statusCode: 200;
}

export interface IGetNewbuildingLayoutsDesktopFicheringResponse400
  extends IModelResponse<IGetNewbuildingLayoutsDesktopFicheringResponseError> {
  statusCode: 400;
}

export interface IGetNewbuildingLayoutsDesktopFicheringResponse {
  /** Планировки **/
  layouts: ILayoutSchema[];
}

export interface IGetNewbuildingLayoutsDesktopFicheringResponseError {
  errors: any[];
  message: string;
}

export type TResponses =
  | IGetNewbuildingLayoutsDesktopFicheringResponse
  | IGetNewbuildingLayoutsDesktopFicheringResponseError;

export enum ERoomsCount {
  /**  **/
  FourPlusRoom = 'fourPlusRoom',
  /**  **/
  OneRoom = 'oneRoom',
  /**  **/
  Studio = 'studio',
  /**  **/
  ThreeRoom = 'threeRoom',
  /**  **/
  TwoRoom = 'twoRoom',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetNewbuildingLayoutsDesktopFicheringResponse): TResponse200;
  400(response: IGetNewbuildingLayoutsDesktopFicheringResponseError): TResponse400;
}
